/* Live bezorgtekst voor elk element met data-cw-countdown (mandlade en winkelwagen). Zelfde regels als de productpagina:
   16:00 uur, geen bezorging op zondag en maandag, feestdagen. Ververst elke paar seconden, ook na het opnieuw tekenen van de lade. */
(function () {
  'use strict';
  if (window.__cwCountdown) return;
  window.__cwCountdown = true;
  var hol = ['2025-12-25','2025-12-26','2026-01-01','2026-04-03','2026-04-05','2026-04-06','2026-04-27','2026-05-05','2026-05-14','2026-05-25','2026-12-25','2026-12-26','2027-01-01','2027-03-26','2027-03-28','2027-03-29','2027-04-27','2027-05-05','2027-05-06','2027-05-17','2027-12-25','2027-12-26'];
  var noDays = [0, 1];
  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function text() {
    var now = new Date();
    var cut = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 16, 0, 0);
    var shipToday = now < cut && now.getDay() !== 0 && now.getDay() !== 6 && hol.indexOf(ymd(now)) < 0;
    var d = add(now, now < cut ? 1 : 2);
    while (noDays.indexOf(d.getDay()) > -1 || hol.indexOf(ymd(d)) > -1) d = add(d, 1);
    var diff = Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
    var dag = diff === 1 ? 'morgen' : diff === 2 ? 'overmorgen' : new Intl.DateTimeFormat('nl-NL', { weekday: 'long' }).format(d);
    var datum = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long' }).format(d);
    if (shipToday) {
      var mins = Math.max(1, Math.floor((cut - now) / 60000)), h = Math.floor(mins / 60), m = mins % 60;
      return 'Bestel binnen <b>' + (h ? h + ' uur en ' : '') + m + ' min</b>, dan is hij er <b>' + dag + '</b> (' + datum + ').';
    }
    return 'Nu besteld, <b>' + dag + '</b> in huis (' + datum + ').';
  }
  function render() {
    var els = document.querySelectorAll('[data-cw-countdown]');
    if (!els.length) return;
    var t = text();
    els.forEach(function (el) { if (el.__t !== t) { el.innerHTML = t; el.__t = t; } });
  }
  render();
  setInterval(render, 2000);
  document.addEventListener('cart:updated', function () { setTimeout(render, 600); });
})();
